"use strict";

exports.__esModule = true;
exports.MAX_CONTENT_PER_CAMPAIGN = exports.PER_PAGE = exports.INSTAGRAM_LOGIN_PERMISSIONS = exports.FACEBOOK_LOGIN_PERMISSIONS = exports.TWITTER_MAX_CHAR_LIMIT = exports.ACCEPTED_FILE_TYPES = exports.ERRORS = exports.ContentActionsTypes = exports.JobStatusToString = exports.JobStatusToEmoji = exports.CLOUD_BUILD_OPERATIONS = exports.JobStatus = exports.DestinationType = exports.ContentType = exports.ENV = exports.LINKED_CLIENT_ID = exports.YOUTUBE_CLIENT_ID = exports.MAILCHIMP_CLIENT_ID = exports.SNIPPET = exports.USHER = exports.FIREBASE_CONFIG = void 0;
var FIREBASE_CONFIG = CONFIG.FIREBASE_CONFIG;
exports.FIREBASE_CONFIG = FIREBASE_CONFIG;
var USHER = CONFIG.USHER;
exports.USHER = USHER;
var SNIPPET = CONFIG.SNIPPET;
exports.SNIPPET = SNIPPET;
var MAILCHIMP_CLIENT_ID = CONFIG.MAILCHIMP.CLIENT_ID;
exports.MAILCHIMP_CLIENT_ID = MAILCHIMP_CLIENT_ID;
var YOUTUBE_CLIENT_ID = CONFIG.YOUTUBE.CLIENT_ID;
exports.YOUTUBE_CLIENT_ID = YOUTUBE_CLIENT_ID;
var LINKED_CLIENT_ID = CONFIG.LINKEDIN.CLIENT_ID;
exports.LINKED_CLIENT_ID = LINKED_CLIENT_ID;
var ENV = CONFIG.ENV;
exports.ENV = ENV;
var ContentType = {
  TEXT: "TEXT",
  FILE: "FILE",
  SNIPPET: "SNIPPET"
};
exports.ContentType = ContentType;
var DestinationType = {
  TWITTER: "TWITTER",
  FACEBOOK: "FACEBOOK",
  MAILCHIMP: "MAILCHIMP",
  INSTAGRAM: "INSTAGRAM",
  YOUTUBE: "YOUTUBE",
  CUSTOM_BACKEND: "CUSTOM_BACKEND",
  LINKEDIN: "LINKEDIN",
  GROUP: "GROUP"
};
exports.DestinationType = DestinationType;
var JobStatus = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  IN_PROGRESS: "IN_PROGRESS"
};
exports.JobStatus = JobStatus;
var CLOUD_BUILD_OPERATIONS = {
  audio_photo_to_video: "audio_photo_to_video",
  audio_audio_to_audio: "audio_audio_to_audio",
  audio_volume: "audio_volume",
  video_volume: "video_volume",
  youtube_upload: "youtube_upload",
  create_thumbnail: "create_thumbnail",
  photo_manipulation: "photo_manipulation",
  cut_video: "cut_video",
  cut_audio: "cut_audio",
  linkedin_token_verification: "linkedin_token_verification",
  scraper: "scraper"
};
exports.CLOUD_BUILD_OPERATIONS = CLOUD_BUILD_OPERATIONS;
var JobStatusToEmoji = {
  PENDING: "⏳",
  SUCCESS: "🟢",
  FAILED: "🔴",
  IN_PROGRESS: "✉️"
};
exports.JobStatusToEmoji = JobStatusToEmoji;
var JobStatusToString = {
  PENDING: "pending",
  SUCCESS: "sent",
  FAILED: "failed",
  IN_PROGRESS: "posting..."
};
exports.JobStatusToString = JobStatusToString;
var ContentActionsTypes = {
  FILE_MANIPULATION: "FILE_MANIPULATION",
  CREATING_SNIPPET_IMAGE: "CREATING_SNIPPET_IMAGE",
  CREATING_THUMBNAIL: "CREATING_THUMBNAIL"
};
exports.ContentActionsTypes = ContentActionsTypes;
var ERRORS = {
  NO_AUTHENTICATION: "NO_AUTHENTICATION"
};
exports.ERRORS = ERRORS;
var ACCEPTED_FILE_TYPES = ["image/*", "audio/*", "video/*"];
exports.ACCEPTED_FILE_TYPES = ACCEPTED_FILE_TYPES;
var TWITTER_MAX_CHAR_LIMIT = 280;
exports.TWITTER_MAX_CHAR_LIMIT = TWITTER_MAX_CHAR_LIMIT;
var FACEBOOK_LOGIN_PERMISSIONS = ["email", "pages_show_list", "pages_manage_posts", "pages_read_engagement"].join(",");
exports.FACEBOOK_LOGIN_PERMISSIONS = FACEBOOK_LOGIN_PERMISSIONS;
var INSTAGRAM_LOGIN_PERMISSIONS = ["email", "pages_show_list", "pages_manage_posts", "pages_read_engagement", "instagram_basic", "instagram_content_publish"];
exports.INSTAGRAM_LOGIN_PERMISSIONS = INSTAGRAM_LOGIN_PERMISSIONS;
var PER_PAGE = 80;
exports.PER_PAGE = PER_PAGE;
var MAX_CONTENT_PER_CAMPAIGN = 100;
exports.MAX_CONTENT_PER_CAMPAIGN = MAX_CONTENT_PER_CAMPAIGN;